import { Component, OnInit, Inject, Output, EventEmitter } from "@angular/core";
import {
  PopupEndPoint,
  AdditionalObservationListViewModel,
  InspectionAdditionalObservationImagesVM,
  InspectionDraftImagesView,
} from "../../../../../app/modules/inspection/models/create-inspection.model";
import { InterpretationService } from "../../interpretation.service";
import { NotificationsService } from "angular2-notifications";
import { TemperatureInspectionService } from "../../../Temperature/temperature-inspection.service";
import { ThermographyInspectionService } from "../../../../../app/modules/Thermography/thermography-inspection.service";
import {
  Condition,
  UpdateComponentPhotoModel,
  AddWSREFrameComponentPhotoModel,
  AddComponentPhotoModel,
  SystemInspectionImagesVM,
  SystemInspectionImagesDetail,
} from "../../models/interpretation.model";
import { DomSanitizer } from "@angular/platform-browser";
import { UserService } from "../../../../../app/shared/services/user.service";
import { EditPhotoComponent } from "../../../../../app/shared/components/edit-photo/edit-photo.component";
import { WsreService } from "../../../../../app/modules/wsre/wsre.service";
import { InventoryService } from "../../../inventory/inventory-service.service";
import { ImageVM } from "../../../inventory/inventory-models";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { BogieImageModel } from "../../../../../app/shared/components/bogie-shim/bogie-shim-model";
import { heicTo } from 'heic-to';

@Component({
  selector: "app-multiple-photo-upload",
  templateUrl: "./multiple-photo-upload.component.html",
  styleUrls: ["./multiple-photo-upload.component.scss"],
})
export class MultiplePhotoUploadComponent implements OnInit {
  conditionType: Condition;
  photoId: number;
  inspectionId: number;
  photoLoading = true;
  photo: string;
  private reloadPhoto = false;
  isInspector = false;
  isInterpreter = false;
  SystemId: number;

  comingFrom: PopupEndPoint;
  @Output() SystemPhotoUpload: EventEmitter<any> = new EventEmitter();
  equipmentId: number;
  inspectionDetailDraftId: number;
  temperatureInspectionId: number;
  temperatureInspectionPhoto: string;

  temperatureInspectionDetailId: number;
  temperatureInspectionDetailPhoto: string;

  thermoInspectionDetailId: number;
  thermoInspectionDetailPhoto: string;
  inspectionDraftId: number;

  additionalObservationList: AdditionalObservationListViewModel;
  imageData: InspectionAdditionalObservationImagesVM;

  isedit: boolean = true;
  IsEditAddInspection: boolean = false;

  photoType: string;
  equipmentid: number;
  img: string;

  TphotoId: number;
  isThermal: boolean;
  side: number;
  IsFinalMeasurementImg: boolean;
  ///new code

  imageTitle: string;
  inspectionDetailId: number;
  photo1: string;
  photo2: string;
  photo3: string;
  photo4: string;
  photo5: string;
  photo1_name: string;
  photo2_name: string;
  photo3_name: string;
  photo4_name: string;
  photo5_name: string;
  photoId1: number;
  photoId2: number;
  photoId3: number;
  photoId4: number;
  photoId5: number;
  InspImage: InspectionDraftImagesView;
  sanitizeImage: boolean = false;
  isWsreFrameObsImage: boolean = false;
  measurementPointId: number;
  componentDetailId: number;
  IsImageUrl: boolean = false;
  Images: any[] = [];
  inspImages: InspectionDraftImagesView[] = [];
  SelectedPhoto: string = "";
  replaced: boolean = false;
  screenId: number;
  imageCount: number;
  selectPhotoId: number;
  constructor(
    private _dialogRef: MatDialogRef<MultiplePhotoUploadComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _editPhotoDialog: MatDialog,
    private _user: UserService,
    private _wsreService: WsreService,
    private _temperatureService: TemperatureInspectionService,
    private _thermographyService: ThermographyInspectionService,
    private inventoryService: InventoryService,
  ) {}

  ngOnInit() {
    // this.IsFinalMeasurementImg =false;
    this.checkPermissions();
    this.comingFrom = this._data.comingFrom;
    this.SystemId = this._data.systemId;
    this.IsEditAddInspection = this._data.IsEditAddInspection;

    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
        case PopupEndPoint.ObservationListInterpretation:
          this.additionalObservationList = this._data.observationList;
          this.imageData = this._data.imageData;
          break;
        case PopupEndPoint.InventoryComponent:
          this.componentDetailId = this._data.componentDetailId;
          //this.getPhoto();
          break;
        case PopupEndPoint.SystemInspectionImages:
          this.componentDetailId = this._data.componentDetailId;
          this.sanitizeImage = true;
          //this.getPhoto();
          break;
      }
    }

    this.isWsreFrameObsImage = this._data.isWsreFrameObsImage;
    this.measurementPointId = this._data.measurementPointId;

    this.isThermal = this._data.isThermal;
    this.TphotoId = this._data.TphotoId;
    this.side = this._data.side;
    this.IsFinalMeasurementImg = this._data.IsFinalMeasurementImg;
    this.temperatureInspectionId = this._data.temperatureInspectionId;
    this.temperatureInspectionPhoto = this._data.temperatureInspectionPhoto;
    this.isedit = this._data.isedit;

    this.temperatureInspectionDetailId =
      this._data.temperatureInspectionDetailId;
    this.temperatureInspectionDetailPhoto =
      this._data.temperatureInspectionDetailPhoto;

    this.thermoInspectionDetailId = this._data.thermoInspectionDetailId;
    this.thermoInspectionDetailPhoto = this._data.thermoInspectionDetailPhoto;

    this.photoId = this._data.photoId;
    this.inspectionId = this._data.inspectionId;
    this.conditionType = this._data.conditionType;
    this.inspectionDraftId = this._data.inspectionDraftId;
    this.inspectionDetailDraftId = this._data.inspectionDraftDetailId;
    this.equipmentId = this._data.equipmentId;
    this.IsImageUrl = this._data.IsImageUrl;
    ((this.photoType = this._data.photoType),
      (this.equipmentid = this._data.equipment_id),
      (this.photo = this._data.img));
    console.log(this._data.photo);
    this.InspImage = this._data.photo;
    console.log("InspImage", this.InspImage, this.Images, this.IsImageUrl);
    //new code
    this.inspectionDetailId = this._data.inspectionDetailId;
    this.inspImages = this._data.inspImg;
    this.Images = [];
    this.Images = this.inspImages?.map((img) => [img.ImagePath, img.Image]);
    this.screenId = this._data.ScreenId;
    // console.log("this.data__111", this._data)
    this.getPhoto();
    if (
      !this.IsImageUrl &&
      this.comingFrom != PopupEndPoint.InventoryComponent
    ) {
      this._dialogRef.beforeClosed().subscribe(() => {
        this._dialogRef.close(this.reloadPhoto);
      });
    } else if (this.comingFrom == PopupEndPoint.SystemInspectionImages) {
    } else {
      this._dialogRef.beforeClosed().subscribe(() => {
        this._dialogRef.close({
          Images: this.Images,
          Close: true,
          ImageCount: this.imageCount,
        });
      });
    }

    if (this.isedit == undefined) {
      this.isedit = true;
    }
    //console.log("isedit", this.isedit)
  }
  onNoClick(): void {
    if (this.comingFrom == PopupEndPoint.SystemInspectionImages) {
      if (!this.IsEditAddInspection) {
        this._dialogRef.close({
          comingFrom: this.comingFrom,
          Close: true,
          SystemId: this.SystemId,
        });
      } else {
        if (this.inspectionId == 0) {
          this._dialogRef.close({
            deletedImageIds: this.deletedImageIds,
            comingFrom: this.comingFrom,
            Close: true,
            SystemId: this.SystemId,
          });
        } else {
          this._dialogRef.close({
            comingFrom: this.comingFrom,
            Close: true,
            SystemId: this.SystemId,
            SystemImages: this.BogieImageModel,
          });
        }
      }
    } else {
      if (this.IsImageUrl)
        this._dialogRef.close({ Images: this.Images, Close: true });
      else this._dialogRef.close(true);
    }
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      (jobRoles) => {
        jobRoles.forEach((role) => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case "Customer Admin":
              this.isInspector = true;
              this.isInterpreter = true;
              break;
          }
        });
      },
      (error) => {
        console.error(error);
        this._notify.error("Error", "Unable to check your job roles. ");
      },
    );
  }

  // editPhoto() {
  //   const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoComponent, {
  //     data: { photoWithExt: this.IsImageUrl? this.photo : 'data:image/png;base64,' + this.photo }
  //   });
  //   editPhotoModalRef.afterClosed().subscribe(res => {
  //     if (res != null) {
  //       this.updatePhoto(res.photo);
  //     }
  //   });
  // }

  editPhoto() {
    if (!this.IsImageUrl) {
      const base64Image = "data:image/png;base64," + this.photo;
      this.openEditModal(base64Image);
      return;
    }
    this._interp.getBase64Image(this.photo).subscribe({
      next: (res: string) => {
        const base64Image = "data:image/png;base64," + res;
        this.openEditModal(base64Image);
      },
      error: (err) => {
        console.error("Error converting image:", err);
        this._notify?.error?.("Error", "Unable to load image for editing.");
      },
    });
  }

  openEditModal(base64Image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoComponent, {
      data: { photoWithExt: base64Image },
    });
    editPhotoModalRef.afterClosed().subscribe((res) => {
      if (res != null) {
        this.photo = res.photo;
        this.updatePhoto(res.photo);
      }
    });
  }

  assignPhotoData(data: string) {
    this.photo = data;
    this.photoLoading = false;
    this.IsImageUrl = this.isImageUrl(data);
  }

  private isImageUrl(data: string): boolean {
    return /^(https?:\/\/|blob:)/i.test(data);
  }

  errorMessage(error: any) {
    console.error(error);
    this._notify.error(
      "Error",
      "Unable to load the photo. Please contact TrackTreads support. ",
    );
  }
  ///This class needs to be refactored
  getPhoto() {
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          this._interp
            .GetObservationListDraftPhoto(
              this.additionalObservationList.Id,
              this.imageData.Id,
            )
            .subscribe(
              (p) => {
                this.assignPhotoData(p);
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.ObservationListInterpretation:
          this._interp
            .GetInspectionObservationListPhoto(
              this.additionalObservationList.Id,
              this.imageData.Id,
            )
            .subscribe(
              (p) => {
                this.assignPhotoData(p);
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.InventoryComponent:
          this.inventoryService
            .getComponentInfoInInventoryImages(this.componentDetailId)
            .subscribe(
              (p) => {
                this.asignInventoryImages(p);
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.SystemInspectionImages:
          this._interp
            .GetSystemImages(this.inspectionId, this.SystemId)
            .subscribe(
              (p) => {
                this.sanitizeImage = true;
                this.asignSystemImages(p.Data);
              },
              (err) => this.errorMessage(err),
            );
          break;
      }
    } else if (
      this.inspectionDraftId !== undefined &&
      this.inspectionDetailDraftId === undefined &&
      !this.isWsreFrameObsImage
    ) {
      //console.log(`Create inspection  ${this.conditionType} on draft id ${this.inspectionDraftId} `);
      this._interp
        .getInspectionDraftConditionPhoto(
          this.inspectionDraftId,
          this.conditionType,
          this.equipmentId,
        )
        .subscribe(
          (p) => {
            this.assignPhotoData(p);
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
    } else if (
      this.inspectionDetailDraftId !== undefined &&
      this.photoId !== undefined &&
      !this.isWsreFrameObsImage
    ) {
      console.log("Create inspection detail this.inspImages", this.inspImages);
      if (
        (!this.inspImages || this.inspImages?.length === 0) &&
        !this.replaced
      ) {
        this.photo1 = this.InspImage?.Image || null;
        this.Images.push([this.InspImage?.ImagePath, this.InspImage?.Image]);
        // this.photo2 = this.InspImage[1].Image;
        // this.photo3 = this.InspImage[2].Image;
        // this.photo4 = this.InspImage[3].Image;
        // this.photo5 = this.InspImage[4].Image;
        this.sanitizeImage = this.IsImageUrl;
        this.LoadselectedImage(this.photo1, this.photo1_name, 1);
      } else {
        this.Images = [];
        this.photo1 = this.inspImages[0]?.Image;
        this.photo2 = this.inspImages[1]?.Image;
        this.photo3 = this.inspImages[2]?.Image;
        this.photo4 = this.inspImages[3]?.Image;
        this.photo5 = this.inspImages[4]?.Image;
        this.Images = this.inspImages.map((img) => [img.ImagePath, img.Image]);
        this.sanitizeImage = this.IsImageUrl;
        this.LoadselectedImage(this.photo1, this.photo1_name, 1);
      }
      // this._interp.getInspectionDetailPhotoList(this.inspectionDetailDraftId, this.equipmentId, this.photoId).subscribe(images => {

      //   this.photo1 = images.photo1;
      //   this.photo1_name = images.photo1_name;
      //   this.photo2 = images.photo2;
      //   this.photo2_name = images.photo2_name;
      //   this.photo3 = images.photo3;
      //   this.photo3_name = images.photo3_name;
      //   this.photo4 = images.photo4;
      //   this.photo4_name = images.photo4_name;
      //   this.photo5 = images.photo5;
      //   this.photo5_name = images.photo5_name;
      //   this.photoId1 = images.photoId1;
      //   this.photoId2 = images.photoId2;
      //   this.photoId3 = images.photoId3;
      //   this.photoId4 = images.photoId4;
      //   this.photoId5 = images.photoId5;

      //   this.LoadselectedImage(images.photo1, images.photo1_name, images.photoId1)

      //   //this.assignPhotoData(this.photo1);
      //   // this.imageTitle = this.photo1_name;

      // }, err => {
      //   this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      // });
    } else if (
      this.inspectionId != undefined &&
      this.photoId !== undefined &&
      !this.isWsreFrameObsImage
    ) {
      // Is a photo attached to a component
      console.log(
        "Component Image",
        this.inspectionId,
        this.inspectionDetailId,
      );
      // this._interp.getComponentPhoto(this.inspectionId, this.photoId).subscribe(p => {
      //   this.assignPhotoData(p);
      // }, err => {
      //   this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      // });

      this._interp
        .getComponentPhotoList(this.inspectionDetailId, this.inspectionId)
        .subscribe(
          (images) => {
            this.photo1 = images.photo1;
            this.photo1_name = images.photo1_name;
            this.photo2 = images.photo2;
            this.photo2_name = images.photo2_name;
            this.photo3 = images.photo3;
            this.photo3_name = images.photo3_name;
            this.photo4 = images.photo4;
            this.photo4_name = images.photo4_name;
            this.photo5 = images.photo5;
            this.photo5_name = images.photo5_name;
            this.photoId1 = images.photoId1;
            this.photoId2 = images.photoId2;
            this.photoId3 = images.photoId3;
            this.photoId4 = images.photoId4;
            this.photoId5 = images.photoId5;
            this.sanitizeImage = false;
            this.IsImageUrl = this.sanitizeImage;
            //this.LoadselectedImage(images.photo1, images.photo1_name, images.photoId1)
            if (this.photoId == images.photoId1) {
              this.LoadselectedImage(
                images.photo1,
                images.photo1_name,
                images.photoId1,
              );
            } else if (this.photoId == images.photoId2) {
              this.LoadselectedImage(
                images.photo2,
                images.photo2_name,
                images.photoId2,
              );
            } else if (this.photoId == images.photoId3) {
              this.LoadselectedImage(
                images.photo3,
                images.photo3_name,
                images.photoId3,
              );
            } else if (this.photoId == images.photoId4) {
              this.LoadselectedImage(
                images.photo4,
                images.photo4_name,
                images.photoId4,
              );
            } else if (this.photoId == images.photoId5) {
              this.LoadselectedImage(
                images.photo5,
                images.photo5_name,
                images.photoId5,
              );
            } else {
              this.LoadselectedImage(
                images.photo1,
                images.photo1_name,
                images.photoId1,
              );
            }

            //
            //this.assignPhotoData(this.photo1);
            //this.imageTitle = this.photo1_name;
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
    } else if (
      this.inspectionId != undefined &&
      this.photoId !== undefined &&
      this.isWsreFrameObsImage
    ) {
      // Is a photo attached to a component
      console.log(
        "WSRE Component Image____",
        this.inspectionId,
        this.inspectionDetailId,
      );
      // let IsFinalMeasurementImg = this.IsFinalMeasurementImg ==undefined ? false:this.IsFinalMeasurementImg;

      this._wsreService
        .getObsPointframePhotoList(
          this.inspectionDetailId,
          this.inspectionId,
          this.side,
          this.IsFinalMeasurementImg,
        )
        .subscribe(
          (images) => {
            this.photo1 = images.photo1;
            this.photo1_name = images.photo1_name;
            this.photo2 = images.photo2;
            this.photo2_name = images.photo2_name;
            this.photo3 = images.photo3;
            this.photo3_name = images.photo3_name;
            this.photo4 = images.photo4;
            this.photo4_name = images.photo4_name;
            this.photo5 = images.photo5;
            this.photo5_name = images.photo5_name;
            this.photoId1 = images.photoId1;
            this.photoId2 = images.photoId2;
            this.photoId3 = images.photoId3;
            this.photoId4 = images.photoId4;
            this.photoId5 = images.photoId5;

            if (images.photo1) {
              this.LoadselectedImage(
                images.photo1,
                images.photo1_name,
                images.photoId1,
              );
            } else {
              // No images left
              this.selectPhotoId = null;
              this.imageTitle = "";
              this.assignPhotoData(null);
              //this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
              this._dialogRef.close(true);
            }

            //if(this.photoId==images.photoId1){
            //this.LoadselectedImage(images.photo1, images.photo1_name, images.photoId1)
            //}
            //else if(this.photoId==images.photoId2){
            //     this.LoadselectedImage(images.photo2, images.photo2_name, images.photoId2)
            //   }
            //   else if(this.photoId==images.photoId3){
            //    this.LoadselectedImage(images.photo3, images.photo3_name, images.photoId3)
            //   }
            //   else if(this.photoId==images.photoId4){
            //    this.LoadselectedImage(images.photo4, images.photo4_name, images.photoId4)
            //   }
            //   else if(this.photoId==images.photoId5){
            //    this.LoadselectedImage(images.photo5, images.photo5_name, images.photoId5)
            //   }else{
            //     this.LoadselectedImage(images.photo1, images.photo1_name, images.photoId1)
            //   }
            //this.assignPhotoData(this.photo1);
            //this.imageTitle = this.photo1_name;
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
    } else {
      console.log("else this.Images.length", this.Images);
      this.sanitizeImage = this.IsImageUrl;
      if (this.Images) {
        if (this.Images.length > 0) {
          this.photo1 = this.Images[0][1];
          this.LoadselectedImage(this.photo1, this.photo1_name, 1);
        }
        if (this.Images.length > 1) {
          this.photo2 = this.Images[1][1];
          this.LoadselectedImage(this.photo2, this.photo1_name, 2);
        }
        if (this.Images.length > 2) {
          this.photo3 = this.Images[2][1];
          this.LoadselectedImage(this.photo3, this.photo1_name, 3);
        }
        if (this.Images.length > 3) {
          this.photo4 = this.Images[3][1];
          this.LoadselectedImage(this.photo4, this.photo1_name, 4);
        }
        if (this.Images.length > 4) {
          this.photo5 = this.Images[4][1];
          this.LoadselectedImage(this.photo5, this.photo1_name, 5);
        }
      }
    }
  }

  LoadselectedImage(
    selectedphoto: string,
    selectedtitle: string,
    selectedPhotoId: number,
  ) {
    //console.log("Image", selectedtitle, selectedPhotoId)
    this.assignPhotoData(selectedphoto);
    this.imageTitle = selectedtitle;
    this.selectPhotoId = selectedPhotoId;
    this.photoId = selectedPhotoId;
    this.SelectedPhoto = selectedphoto;
    //console.log(selectedphoto);
    //console.log(selectedPhotoId);
  }
  deletePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
    //this._dialogRef.close();
    this.getPhoto();
  }
  deletedImageIds: number[] = [];

  updatePhotoError(title: string, message: string) {
    this._notify.error(title, message);
    console.error(message);
    this.photoLoading = false;
  }

  deletePhoto() {
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          this._interp
            .DeleteObservationListDraftPhoto(
              this.additionalObservationList.Id,
              this.imageData.Id,
            )
            .subscribe(
              (r) => {
                this.deletePhotoSuccess(
                  "Deleted",
                  "Observation List Image has been successfully removed",
                );
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.ObservationListInterpretation:
          this._interp
            .DeleteInspectionObservationListPhoto(
              this.additionalObservationList.Id,
              this.imageData.Id,
            )
            .subscribe(
              (r) => {
                this.deletePhotoSuccess(
                  "Deleted",
                  "Observation List Image has been successfully removed",
                );
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.InventoryComponent:
          this.inventoryService
            .deleteComponentInfoInInventoryImage(this.photoId, this.screenId)
            .subscribe(
              (p) => {
                this.deletePhotoSuccess(
                  "Deleted",
                  "Image has been successfully removed",
                );
              },
              (err) => this.errorMessage(err),
            );
          break;
        case PopupEndPoint.SystemInspectionImages:
          this._interp.DeleteSystemInspectionImages(this.photoId).subscribe(
            (p) => {
              if (this.IsEditAddInspection) {
                this.deletedImageIds.push(this.photoId);
              }
              this.SystemPhotoUpload.emit({
                imagePath: p,
                SystemId: this.SystemId,
              });
              this.deletePhotoSuccess(
                "Deleted",
                "Image has been successfully removed",
              );
            },
            (err) => this.errorMessage(err),
          );
          break;
      }
    } else if (
      this.inspectionDraftId !== undefined &&
      this.inspectionDetailDraftId === undefined
    ) {
      console.log(
        `Delete  ${this.conditionType} on draft id ${this.inspectionDraftId} `,
      );
      if (this.IsImageUrl) {
        if (!this.SelectedPhoto || !this.Images) return;

        const index = this.Images.findIndex(
          (img) => img[1] === this.SelectedPhoto,
        );

        if (index === -1) return;

        this.Images.splice(index, 1);

        if (this.photo1 === this.SelectedPhoto) this.photo1 = null;
        if (this.photo2 === this.SelectedPhoto) this.photo2 = null;
        if (this.photo3 === this.SelectedPhoto) this.photo3 = null;
        if (this.photo4 === this.SelectedPhoto) this.photo4 = null;
        if (this.photo5 === this.SelectedPhoto) this.photo5 = null;

        this.photo1 = this.Images[0]?.[1] || null;
        this.photo2 = this.Images[1]?.[1] || null;
        this.photo3 = this.Images[2]?.[1] || null;
        this.photo4 = this.Images[3]?.[1] || null;
        this.photo5 = this.Images[4]?.[1] || null;

        if (this.photo1) {
          this.LoadselectedImage(this.photo1, "", 1);
        } else {
          // No images left
          this.selectPhotoId = null;
          this.imageTitle = "";
          this.assignPhotoData(null);
          this.deletePhotoSuccess(
            "Deleted",
            "Image has been successfully removed",
          );
          this._dialogRef.close({ Images: this.Images, Close: true });
        }
      } else {
        this._interp
          .deleteDraftConditionPhoto(
            this.inspectionDraftId,
            this.conditionType,
            this.equipmentId,
          )
          .subscribe(
            (p) => {
              this.deletePhotoSuccess(
                "Deleted",
                "Image has been successfully removed",
              );
            },
            (err) => {
              this.updatePhotoError(
                "Failed",
                "Unable to delete the photo. Please contact TrackTreads support. ",
              );
            },
          );
      }
    } else if (
      this.inspectionDetailDraftId !== undefined &&
      this.photoId !== undefined
    ) {
      console.log("Delete 1: ", this.inspectionDetailDraftId, this.photoId);
      if (this.IsImageUrl) {
        if (!this.SelectedPhoto || !this.Images) return;
        const index = this.Images.findIndex(
          (img) => img[1] === this.SelectedPhoto,
        );
        if (index === -1) return;
        this.Images.splice(index, 1);
        if (this.photo1 === this.SelectedPhoto) this.photo1 = null;
        if (this.photo2 === this.SelectedPhoto) this.photo2 = null;
        if (this.photo3 === this.SelectedPhoto) this.photo3 = null;
        if (this.photo4 === this.SelectedPhoto) this.photo4 = null;
        if (this.photo5 === this.SelectedPhoto) this.photo5 = null;

        this.photo1 = this.Images[0]?.[1] || null;
        this.photo2 = this.Images[1]?.[1] || null;
        this.photo3 = this.Images[2]?.[1] || null;
        this.photo4 = this.Images[3]?.[1] || null;
        this.photo5 = this.Images[4]?.[1] || null;
        console.log("Delete 2 this.Images: ", this.Images, this.photo1);
        if (this.photo1) {
          this.LoadselectedImage(this.photo1, "", 1);
        } else {
          // No images left
          this.selectPhotoId = null;
          this.imageTitle = "";
          this.assignPhotoData(null);
          //this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
          this._dialogRef.close({ Images: this.Images, Close: true });
        }
      } else {
        this._interp
          .deleteInspectionDetailPhoto(
            this.inspectionDetailDraftId,
            this.equipmentId,
            this.photoId,
          )
          .subscribe(
            (p) => {
              this.deletePhotoSuccess(
                "Deleted",
                "Image has been successfully removed",
              );
            },
            (err) => {
              this.updatePhotoError(
                "Failed",
                "Unable to delete the photo. Please contact TrackTreads support. ",
              );
            },
          );
      }
    } else if (
      this.inspectionId !== undefined &&
      this.photoId !== undefined &&
      !this.isWsreFrameObsImage
    ) {
      // Is a photo attached to a component
      this._interp
        .deleteComponentPhoto(this.inspectionId, this.photoId, this.screenId)
        .subscribe(
          (p) => {
            if (p.m_Item1) {
              this.deletePhotoSuccess("Deleted", p.m_Item2);
              console.log("deletePhotoSuccess", this.photoId1, this.photoId2);
              if (!this.photoId2 && this.photoId == this.photoId1) {
                //console.log("deletePhotoSuccess", this.IsImageUrl)
                this.selectPhotoId = null;
                this.imageTitle = "";
                this.assignPhotoData(null);
                //this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
                if (!this.IsImageUrl) this._dialogRef.close(true);
                else
                  this._dialogRef.close({ Images: this.Images, Close: true });
              }
            } else {
              this.updatePhotoError(
                "Failed",
                "Unable to delete the photo. Please contact TrackTreads support. ",
              );
            }
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
    }
    // TT-9006 method created to delete wsre frame obs image
    else if (
      this.inspectionId != undefined &&
      this.photoId !== undefined &&
      this.isWsreFrameObsImage
    ) {
      this._wsreService
        .DeleteFrameObsImage(this.photoId, this.screenId)
        .subscribe(
          (p) => {
            this.deletePhotoSuccess(
              "Deleted",
              "Image has been successfully removed",
            );
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
    } else {
      if (!this.SelectedPhoto || !this.Images) return;
      const index = this.Images.findIndex(
        (img) => img[1] === this.SelectedPhoto,
      );

      if (index === -1) return;

      this.Images.splice(index, 1);

      if (this.photo1 === this.SelectedPhoto) this.photo1 = null;
      if (this.photo2 === this.SelectedPhoto) this.photo2 = null;
      if (this.photo3 === this.SelectedPhoto) this.photo3 = null;
      if (this.photo4 === this.SelectedPhoto) this.photo4 = null;
      if (this.photo5 === this.SelectedPhoto) this.photo5 = null;

      this.photo1 = this.Images[0]?.[1] || null;
      this.photo2 = this.Images[1]?.[1] || null;
      this.photo3 = this.Images[2]?.[1] || null;
      this.photo4 = this.Images[3]?.[1] || null;
      this.photo5 = this.Images[4]?.[1] || null;

      if (this.photo1) {
        this.LoadselectedImage(this.photo1, "", 1);
      } else {
        this.selectPhotoId = null;
        this.imageTitle = "";
        this.assignPhotoData(null);
        this.deletePhotoSuccess(
          "Deleted",
          "Image has been successfully removed",
        );
        this._dialogRef.close({ Images: this.Images, Close: true });
      }
    }
  }

  updatePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
    this.getPhoto();
  }

  BogieImageModel: BogieImageModel[] = [];
  updatePhoto(newPhoto: string) {
    this.photoLoading = true;
    //console.log("Updateee", this.equipmentid, this.comingFrom)
    if (this.comingFrom == PopupEndPoint.InventoryComponent) {
      const _ObjImage = new ImageVM();
      _ObjImage.Id = this.selectPhotoId;
      _ObjImage.Image = newPhoto;
      _ObjImage.ReferenceTableId = this.componentDetailId;
      _ObjImage.ScreenId = this.screenId;
      this.inventoryService
        .updateComponentInfoInInventoryImages(_ObjImage)
        .subscribe((p) => {
          if (p.m_Item1) {
            this.updatePhotoSuccess("Updated", p.m_Item2);
          } else {
            this.updatePhotoError(
              "Failed",
              "Unable to update the photo. Please contact TrackTreads support.",
            );
          }
        });
    } else if (this.comingFrom == PopupEndPoint.SystemInspectionImages) {
      const _ObjImage = new ImageVM();
      _ObjImage.Id = this.selectPhotoId;
      _ObjImage.Image = newPhoto;
      _ObjImage.ReferenceTableId = this.componentDetailId;
      _ObjImage.ScreenId = this.screenId;
      _ObjImage.IsEditAddInspection = this.IsEditAddInspection;
      this._interp.updateSystemImages(_ObjImage).subscribe((p) => {
        if (p.ImageStatus) {
          if (!this.IsEditAddInspection) {
            this.SystemPhotoUpload.emit({
              imagePath: p,
              SystemId: this.SystemId,
            });
            this.updatePhotoSuccess(
              "Updated",
              "Images have been successfully updated",
            );
          } else {
            this.BogieImageModel.push({
              ImagePath: p.ImagePath,
              ImageUrl: p.ImageUrl,
              IsInterp: false,
              ImageStatus: p.ImageStatus,
              Id: this.SystemId,
            });
            this.updatePhotoSuccess(
              "Updated",
              "Images have been successfully updated",
            );
          }
        } else {
          this.updatePhotoError(
            "Failed",
            "Unable to update the photo. Please contact TrackTreads support.",
          );
        }
      });
    } else {
      // Is a condition photo. Like track sag for example.
      if (
        this.inspectionDetailDraftId !== undefined &&
        this.photoId !== undefined &&
        !this.isWsreFrameObsImage
      ) {
        if (this.IsImageUrl) {
          const photo = new AddComponentPhotoModel();
          photo.NewPhoto = newPhoto;
          this.photoId = undefined;
          this._interp.addInspectionComponentPhoto(photo).subscribe((p) => {
            if (p.ImagePath != "" || p.ImagePath != null) {
              console.log(p.ImagePath, p.ImageUrl);
              console.log(this.Images);
              if (this.selectPhotoId > 0) {
                const index = this.selectPhotoId - 1;
                console.log("Update mode. Index:", index);
                if (index < this.Images.length) {
                  this.Images[index] = [p.ImagePath, p.ImageUrl];
                  this.replaced = true;
                } else {
                  console.log("Add mode 1");
                  this.Images.push([p.ImagePath, p.ImageUrl]);
                }
              } else {
                console.log("Add mode 0");
                this.Images.push([p.ImagePath, p.ImageUrl]);
              }
              //this.inspImages = [...this.Images];
              //this.Images.push([p.ImagePath, p.ImageUrl]);
              console.log(this.Images);
              this.updatePhotoSuccess(
                "Uploaded",
                "Image Uploaded Successfully",
              );
            } else {
              this.updatePhotoError(
                "Failed",
                "Unable to upload the photo. Please contact TrackTreads support.",
              );
            }
          });
        } else {
          const photo = new UpdateComponentPhotoModel();
          photo.NewPhoto = newPhoto;
          //photo.PhotoId = this.selectPhotoId > 0 ? this.selectPhotoId : this.photoId;
          photo.PhotoId = this.selectPhotoId;
          photo.InspectionId = this.inspectionDraftId;
          photo.InspectionDetailId = this.inspectionDetailDraftId;
          photo.Title = this.imageTitle;
          this._interp
            .updateComponentPhotoOnInspectionDraft(photo)
            .subscribe((p) => {
              if (p.m_Item1) {
                this.updatePhotoSuccess("Updated", p.m_Item2);
              } else {
                this.updatePhotoError(
                  "Failed",
                  "Unable to delete the photo. Please contact TrackTreads support. ",
                );
              }
            });
        }
        //console.log(`Create inspection detail  ${this.inspectionDetailDraftId} `);
      } else if (!this.isWsreFrameObsImage) {
        // Is a photo attached to a component
        if (this.IsImageUrl) {
          const photo = new AddComponentPhotoModel();
          photo.NewPhoto = newPhoto;
          this._interp.addInspectionComponentPhoto(photo).subscribe((p) => {
            if (p.ImagePath != "" || p.ImagePath != null) {
              this.Images = [];
              console.log(p.ImagePath, p.ImageUrl);
              this.Images.push([p.ImagePath, p.ImageUrl]);
              console.log(this.Images);
              this.updatePhotoSuccess(
                "Uploaded",
                "Image Uploaded Successfully",
              );
            } else {
              this.updatePhotoError(
                "Failed",
                "Unable to upload the photo. Please contact TrackTreads support.",
              );
            }
          });
        } else {
          const photo = new UpdateComponentPhotoModel();
          photo.InspectionId = this.inspectionId;
          photo.NewPhoto = newPhoto;
          photo.InspectionDetailId = this.inspectionDetailId;
          //photo.PhotoId = this.selectPhotoId > 0 ? this.selectPhotoId : this.photoId;
          photo.PhotoId = this.selectPhotoId;
          photo.Title = this.imageTitle;
          photo.ScreenId = this.screenId;
          // this.photoId = this.selectPhotoId;
          console.log("Photo__", photo);
          this._interp.updateComponentPhoto_New(photo).subscribe(
            (p) => {
              if (p.m_Item1) {
                this.updatePhotoSuccess("Updated", p.m_Item2);
              } else {
                this.updatePhotoError(
                  "Failed",
                  "Unable to delete the photo. Please contact TrackTreads support. ",
                );
              }
            },
            (err) => {
              this.updatePhotoError(
                "Failed",
                "Unable to delete the photo. Please contact TrackTreads support. ",
              );
            },
          );
        }
      } else {
        // Is a photo attached to a component
        const photo = new AddWSREFrameComponentPhotoModel();
        photo.WSREID = this.inspectionId;
        photo.NewPhoto = newPhoto;
        photo.CompartMeasurementPointId = this.inspectionDetailId;
        //photo.PhotoId = this.selectPhotoId > 0 ? this.selectPhotoId : this.photoId;
        photo.PhotoId = this.selectPhotoId;
        photo.Title = this.imageTitle;
        photo.side = this.side;
        photo.WSREMeasurementPointId = this.measurementPointId;
        photo.ScreenId = this.screenId;
        // this.photoId = this.selectPhotoId;
        console.log("WSRE___Photo__", photo);
        this._wsreService.UpdateWSREFrameObspointPhotoNew(photo).subscribe(
          (p) => {
            if (p.m_Item1) {
              this.updatePhotoSuccess("Updated", p.m_Item2);
            } else {
              this.updatePhotoError(
                "Failed",
                "Unable to delete the photo. Please contact TrackTreads support. ",
              );
            }
          },
          (err) => {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          },
        );
      }
    }
  }

  async replacePhotoClicked(event: any, photoId: number) {

  if (this.comingFrom == PopupEndPoint.InventoryComponent)
    this.selectPhotoId = photoId == 0 ? this.photoId : 0;
  else
    this.selectPhotoId = photoId == 0 ? this.photoId : photoId;

  console.log("image upload started this.selectPhotoId", this.selectPhotoId);

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;
  // this._cdr.detectChanges();

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.updatePhoto(res.split(",")[1]);
          }

        })
        .catch(err => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);
  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",   // If your version requires it, change to toType
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    this.photoLoading = false;

    console.error("HEIC conversion failed", err);

    this._notify.error(
      "Error",
      "Unable to update the photo. Please contact support."
    );

  }

  event.target.value = null;
}
  // replacePhotoClicked(event: any, photoId: number) {
  //   if (this.comingFrom == PopupEndPoint.InventoryComponent)
  //     this.selectPhotoId = photoId == 0 ? this.photoId : 0;
  //   else this.selectPhotoId = photoId == 0 ? this.photoId : photoId;
  //   console.log("image upload started this.selectPhotoId", this.selectPhotoId);
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     //this._cdr.detectChanges();
  //     let file = event.target.files[0];
  //     const isHeic =
  //       file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl).then((res: string) => {
  //           if (res) {
  //             this.updatePhoto(res.split(",")[1]);
  //           }
  //         });
  //       };
  //       reader.readAsDataURL(f);
  //     };
  //     if (isHeic) {
  //       (heic2any as any)
  //         .default({
  //           blob: file,
  //           toType: "image/jpeg",
  //           quality: 0.8,
  //         })
  //         .then((result: any) => {
  //           const convertedBlob = Array.isArray(result) ? result[0] : result;
  //           const convertedFile = new File([convertedBlob], "converted.jpg", {
  //             type: "image/jpeg",
  //           });
  //           processFile(convertedFile);
  //         })
  //         .catch((err: any) => {
  //           this.photoLoading = false;
  //           console.error("HEIC conversion failed", err);
  //           this._notify.error(
  //             "Error",
  //             "Unable to update the photo. Please contact support.",
  //           );
  //         });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  // replacePhotoClicked(event: any, photoId: number) {
  //   if(this.comingFrom == PopupEndPoint.InventoryComponent)
  //     this.selectPhotoId = photoId == 0 ? this.photoId : 0;
  //   else
  //     this.selectPhotoId = photoId == 0 ? this.photoId : photoId;
  //   console.log('image upload started this.selectPhotoId', this.selectPhotoId);
  //   //this.selectPhotoId = photoId == 1 ? this.photoId : 0;
  //   if (event.target.files && event.target.files[0]) {
  //     // this.updatePhoto(event.target.files[0]);.
  //     // var maxsize = 2048000;
  //     // if (event.target.files[0].size > maxsize) {
  //     //   alert("This image is too large. Image file size must be 2MB or less.")
  //     // } else {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (event) => {
  //         //  this.updatePhoto(event.target.result.split(',')[1]);
  //         const imageUrl = (event.target["result"]);
  //         //resize photo
  //         this.compressImage(imageUrl).then((res: string) => {
  //           // console.log("imageUrl", res)
  //           if (res) {
  //             //console.log('res', res)

  //             //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //             this.updatePhoto(res.split(',')[1]);
  //           }
  //         })
  //       };
  //     //}
  //   }
  // }

  sanitize(image: string, sanitizeImage: boolean) {
    if (!sanitizeImage)
      return this._sanitizer.bypassSecurityTrustResourceUrl(
        "data:image/png;base64," + image,
      );
    else return image;
  }
  UpdateTitle() {
    if (
      this.inspectionDetailId != undefined ||
      this.inspectionDetailId != null
    ) {
      const photo = new UpdateComponentPhotoModel();
      photo.InspectionId = this.inspectionId;
      photo.InspectionDetailId = this.inspectionDetailId;
      photo.PhotoId = this.selectPhotoId;
      photo.Title = this.imageTitle;
      console.log("Title___", photo);
      this._interp.updateComponentPhotoTitle(photo).subscribe(
        (p) => {
          if (p.m_Item1) {
            this.updatePhotoSuccess("Updated", p.m_Item2);
          } else {
            this.updatePhotoError(
              "Failed",
              "Unable to delete the photo. Please contact TrackTreads support. ",
            );
          }
        },
        (err) => {
          this.updatePhotoError(
            "Failed",
            "Unable to delete the photo. Please contact TrackTreads support. ",
          );
        },
      );
    } else {
      const photo = new UpdateComponentPhotoModel();
      photo.InspectionId = this.inspectionDraftId;
      photo.InspectionDetailId = this.inspectionDetailDraftId;
      photo.PhotoId = this.selectPhotoId;
      photo.Title = this.imageTitle;
      console.log("Title___", photo);
      this._interp.updateComponentPhotoTitle_Inspection(photo).subscribe(
        (p) => {
          if (p.m_Item1) {
            this.updatePhotoSuccess("Updated", p.m_Item2);
          } else {
            this.updatePhotoError(
              "Failed",
              "Unable to update the photo title. Please contact TrackTreads support. ",
            );
          }
        },
        (err) => {
          this.updatePhotoError(
            "Failed",
            "Unable to update the photo title. Please contact TrackTreads support. ",
          );
        },
      );
    }
  }

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement("canvas");
        let width, height;
        width = img.width;
        height = img.height;
        console.log("width", width);
        console.log("height", height);
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800; //643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext("2d");
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
      img.onerror = (error) => rej(error);
    });
  }
  private asignInventoryImages(images: ImageVM[]) {
    this.photoId = 0;
    this.selectPhotoId = 0;
    this.photo1 = null;
    this.photoId1 = 0;
    this.photo2 = null;
    this.photoId2 = 0;
    this.photo3 = null;
    this.photoId3 = 0;
    this.photo4 = null;
    this.photoId4 = 0;
    this.photo5 = null;
    this.photoId5 = 0;
    if (images.length > 0) {
      this.photo1 = images[0].Image;
      this.photo1_name = "";
      this.photoId1 = images[0].Id;
    }
    if (images.length > 1) {
      this.photo2 = images[1].Image;
      this.photo2_name = "";
      this.photoId2 = images[1].Id;
    }
    if (images.length > 2) {
      this.photo3 = images[2].Image;
      this.photo3_name = "";
      this.photoId3 = images[2].Id;
    }
    if (images.length > 3) {
      this.photo4 = images[3].Image;
      this.photo4_name = "";
      this.photoId4 = images[3].Id;
    }
    if (images.length > 4) {
      this.photo5 = images[4].Image;
      this.photo5_name = "";
      this.photoId5 = images[4].Id;
    }
    this.sanitizeImage = false;
    if (images.length <= 0) {
      this.imageCount = images.length;
      this.selectPhotoId = null;
      this.imageTitle = "";
      this.assignPhotoData(null);
      this._dialogRef.close({ imageCount: 0, success: true });
    } else this.LoadselectedImage(this.photo1, this.photo1_name, this.photoId1);
  }
  SystemInspectionImagesVM: SystemInspectionImagesVM;
  SystemInspectionImagesDetail: SystemInspectionImagesDetail[] = [];

  private asignSystemImages(images: SystemInspectionImagesDetail[]) {
    this.photoId = 0;
    this.selectPhotoId = 0;
    this.photo1 = null;
    this.photoId1 = 0;
    this.photo2 = null;
    this.photoId2 = 0;
    this.photo3 = null;
    this.photoId3 = 0;
    this.photo4 = null;
    this.photoId4 = 0;
    this.photo5 = null;
    this.photoId5 = 0;
    if (images.length > 0) {
      this.photo1 = images[0].ImagePath;
      this.photo1_name = "";
      this.photoId1 = images[0].Id;
    }
    if (images.length > 1) {
      this.photo2 = images[1].ImagePath;
      this.photo2_name = "";
      this.photoId2 = images[1].Id;
    }
    if (images.length > 2) {
      this.photo3 = images[2].ImagePath;
      this.photo3_name = "";
      this.photoId3 = images[2].Id;
    }
    if (images.length > 3) {
      this.photo4 = images[3].ImagePath;
      this.photo4_name = "";
      this.photoId4 = images[3].Id;
    }
    if (images.length > 4) {
      this.photo5 = images[4].ImagePath;
      this.photo5_name = "";
      this.photoId5 = images[4].Id;
    }
    this.sanitizeImage = true;
    if (images.length <= 0) {
      this.imageCount = images.length;
      this.selectPhotoId = null;
      this.imageTitle = "";
      this.asignSystemImages(null);
      this._dialogRef.close({ imageCount: 0, success: true });
    } else this.LoadselectedImage(this.photo1, this.photo1_name, this.photoId1);
  }
  // openLargeImage(base64Data: string): void {
  //   let imageBase64 = ""
  //   if (!this.sanitizeImage) {
  //     imageBase64 = 'data:image/jpeg;base64,' + base64Data;
  //   } else {
  //     imageBase64 = base64Data;
  //   }

  //   const newWindow = window.open('', '_blank');
  //   if (newWindow) {
  //     newWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>Image Viewer</title>
  //         <style>
  //           body {
  //             margin: 0;
  //             padding: 0;
  //             display: flex;
  //             flex-direction: column;
  //             align-items: center;
  //             justify-content: center;
  //             background-color: #f0f0f0;
  //           }
  //           img {
  //             max-width: 90vw;
  //             max-height: 80vh;
  //             margin-top: 20px;
  //           }
  //           button {
  //             margin-top: 20px;
  //             padding: 10px 20px;
  //             font-size: 16px;
  //             cursor: pointer;
  //             background-color: #e74c3c;
  //             color: white;
  //             border: none;
  //             border-radius: 5px;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <img src="${imageBase64}" alt="Image"/>
  //         <button onclick="window.close()">Close</button>
  //       </body>
  //     </html>
  //   `);
  //     newWindow.document.close();
  //   } else {
  //     alert('Popup blocked. Please allow popups for this website.');
  //   }
  // }

  openLargeImage(base64Data: string): void {
    const imageBase64 = this.sanitizeImage
      ? base64Data
      : `data:image/jpeg;base64,${base64Data}`;

    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newWindow = window.open(
      "",
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`,
    );

    if (!newWindow) {
      alert("Popup blocked. Please allow popups for this website.");
      return;
    }

    newWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Image Viewer</title>

<style>

html,body{
    margin:0;
    width:100%;
    height:100%;
    overflow:hidden;
    background:#000;
    font-family:Arial,Helvetica,sans-serif;
}

.toolbar{
    position:fixed;
    top:12px;
    left:50%;
    transform:translateX(-50%);
    display:flex;
    align-items:center;
    justify-content:space-between;
    min-width:430px;
    padding:6px 8px;
    background:rgba(35,35,35,.92);
    border-radius:8px;
    box-shadow:0 4px 15px rgba(0,0,0,.45);
    z-index:9999;
}

.toolbar-left{
    display:flex;
    align-items:center;
    gap:6px;
}
.toolbar button{
    height:30px;
    min-width:30px;
    border:none;
    border-radius:4px;
    background:#1976d2;
    color:#fff;
    font-size:14px;
    font-weight:600;
    cursor:pointer;
    padding:0 8px;
    transition:.2s;
}

.toolbar button:hover{
    background:#1565c0;
}

.zoomText{
    color:#fff;
    min-width:46px;
    text-align:center;
    font-size:14px;
    font-weight:600;
}

.fit-btn{
    min-width:82px;
}

.close-btn{
    margin-left:12px;
    width:30px !important;
    min-width:30px !important;
    height:30px;
    padding:0 !important;
    background:#d32f2f !important;
    font-size:18px !important;
    font-weight:bold;
    line-height:30px;
}

.close-btn:hover{
    background:#b71c1c !important;
}

.viewer{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;
    cursor:grab;
}

.viewer:active{
    cursor:grabbing;
}

img{
    user-select:none;
    -webkit-user-drag:none;
    transform-origin:center center;
    transition:transform .08s linear;
    max-width:none;
    max-height:none;
}

</style>

</head>

<body>

<div class="toolbar">
    <div class="toolbar-left">
        <button id="zoomOut" title="Zoom Out">−</button>

        <span id="zoomValue" class="zoomText">125%</span>

        <button id="zoomIn" title="Zoom In">+</button>

        <button id="reset" title="Reset Zoom">125%</button>

        <button id="fit" class="fit-btn">Screen Fit</button>
    </div>

    <button class="close-btn" title="Close" onclick="window.close()">
        &#10005;
    </button>
</div>

<div class="viewer" id="viewer">
    <img id="img" src="${imageBase64}" draggable="false"/>
</div>

<script>

const img=document.getElementById('img');
const viewer=document.getElementById('viewer');
const zoomText=document.getElementById('zoomValue');

let scale=1.25;
let posX=0;
let posY=0;
let isDragging=false;
let startX=0;
let startY=0;

function updateImage(){

    img.style.transform =
        'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';

    zoomText.innerText = Math.round(scale * 100) + '%';

    viewer.style.cursor = canDrag() ? 'grab' : 'default';
}

updateImage();

document.getElementById('zoomIn').onclick=function(){
    scale = Math.min(scale + 0.1, 5);
    updateImage();
};

document.getElementById('zoomOut').onclick=function(){
    if(scale>0.2){
        scale = Math.max(scale - 0.1, 0.2);
        updateImage();
    }
};

document.getElementById('reset').onclick=function(){
    scale = 1.25;
    posX=0;
    posY=0;
    updateImage();
};

document.getElementById('fit').onclick=function(){

    const vw=viewer.clientWidth;
    const vh=viewer.clientHeight;

    const iw=img.naturalWidth;
    const ih=img.naturalHeight;

    scale = Math.min(vw / iw, vh / ih) * 0.95;

    posX=0;
    posY=0;

    updateImage();
};

function canDrag() {
    return true;
}

viewer.addEventListener('wheel',function(e){

    e.preventDefault();

    if(e.deltaY<0)
        scale+=0.1;
    else if(scale>0.2)
        scale-=0.1;

    updateImage();

},{passive:false});

viewer.addEventListener('mousedown', function (e) {

    if (!canDrag()) return;

    isDragging = true;

    startX = e.clientX - posX;
    startY = e.clientY - posY;

    viewer.style.cursor = 'grabbing';

    e.preventDefault();

});

window.addEventListener('mousemove',function(e){

    if(!isDragging) return;

    posX=e.clientX-startX;
    posY=e.clientY-startY;

    updateImage();

});

window.addEventListener('mouseup', function () {

    isDragging = false;

    viewer.style.cursor = canDrag() ? 'grab' : 'default';

});

</script>

</body>

</html>
`);

    newWindow.document.close();
    newWindow.focus();

    newWindow.moveTo(0, 0);
    newWindow.resizeTo(width, height);
  }
}
